import { Card, Col, Container, Row } from "react-bootstrap";
import bg37 from "assets/img/bg/37.png";
import SignUpPaidForm from "components/modules/auth/SignUpPaidForm";

const SignUpPaid = () => {
  return (
    <Container fluid className="bg-body-tertiary dark__bg-gray-1200">
      <div
        className="bg-holder bg-auth-card-overlay"
        style={{ backgroundImage: `url(${bg37})` }}
      />

      <Row className="flex-center position-relative min-vh-100 g-0 py-5">
        <Col xs={11} sm={10} xl={6}>
          <Card className="border border-translucent auth-card">
            <Card.Body>
              <div className="p-2 p-md-4 p-lg-8">
                <SignUpPaidForm />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SignUpPaid;
